const SetupWorkCode = (() => {
    let workCodeData, workCodeTable;

    function getWorkCodeView() {
        const frag = document.createDocumentFragment();

        workCodeTable = table.build({
            tableId: 'codeWorkTable',
            columnHeadings: ['Work Code', 'Description', 'Active?', 'Create Billing?', 'Create Payroll?'],
            endIcon: true,
        });

        const headers = workCodeTable.querySelectorAll('.header div');
        headers[0].setAttribute('data-type', 'string');
        headers[1].setAttribute('data-type', 'string');
        headers[2].setAttribute('data-type', 'string');
        headers[3].setAttribute('data-type', 'string');
        headers[4].setAttribute('data-type', 'string');

        const addWorkCodeBtnDiv = document.createElement('div');
        const addWorkCodeBtn = new Button({
            text: 'ADD NEW WORK CODE',
            style: 'primary',
            icon: 'add',
            styleType: 'outlined',
        });

        frag.append(workCodeTable);
        if ($.session.SetupInsert) {
            addWorkCodeBtn.button.style.float = 'right';
            addWorkCodeBtn.renderTo(addWorkCodeBtnDiv);
            frag.append(addWorkCodeBtnDiv);
        }

        const tableWorkCodeData = workCodeData
            .map(cd => {
                return {
                    values: [cd.WorkCode, cd.Description, cd.IsActive == 'Y' ? 'Yes' : 'No', cd.IsCreateBilling == 'Y' ? 'Yes' : 'No', cd.IsCreatePayroll == 'Y' ? 'Yes' : 'No'],
                    endIcon: $.session.SetupDelete ? icons['delete'] : '',
                    onClick: e => {
                        showWorkCodePopup(cd);
                    },
                    endIconCallback: () => handleWorkCodeDelete(cd),
                };
            });

        table.populate(workCodeTable, tableWorkCodeData);
        table.sortTableByHeader(workCodeTable);

        addWorkCodeBtn.onClick(e => {
            showWorkCodePopup();
        });
        return frag;
    }

    function getParentWorkCode() {
        let data = [];
        for (const cd of workCodeData) {
            if (cd.IsActive == 'Y' && cd.IsCreateBilling == 'Y') {
                data.push({
                    value: cd.WorkCodeId,
                    text: cd.WorkCode + ' - ' + cd.Description,
                });
            }
        }
        return data;
    }

    function showWorkCodePopup(rowData) {
        const popup = POPUP.build({
            classNames: 'codeWorkPopup',
            hideX: true,
        });

        const workCodeForm = new Form({
            fields: [
                {
                    type: 'text',
                    label: 'Work Code',
                    id: 'wWorkCode',
                    required: true,
                    maxlength: 5,
                },
                {
                    type: 'text',
                    label: 'Description',
                    id: 'wDescription',
                    required: true,
                    maxlength: 50,
                },
                {
                    type: 'select',
                    label: 'Active?',
                    id: 'wActive',
                    data: [
                        { value: 'Y', text: 'Yes' },
                        { value: 'N', text: 'No' },
                    ],
                },
                {
                    type: 'select',
                    label: 'Create Billing?',
                    id: 'wCreateBilling',
                    data: [
                        { value: 'Y', text: 'Yes' },
                        { value: 'N', text: 'No' },
                    ],
                },
                {
                    type: 'select',
                    label: 'Create Payroll?',
                    id: 'wCreatePayroll',
                    data: [
                        { value: 'Y', text: 'Yes' },
                        { value: 'N', text: 'No' },
                    ],
                },
                {
                    type: 'select',
                    label: 'Key Times?',
                    id: 'wKeyTimes',
                    data: [
                        { value: 'Y', text: 'Yes' },
                        { value: 'N', text: 'No' },
                    ],
                },
                {
                    type: 'select',
                    label: 'Allow Payroll Overlaps?',
                    id: 'wAllowPayrollOverlaps',
                    data: [
                        { value: 'Y', text: 'Yes' },
                        { value: 'N', text: 'No' },
                    ],
                },
                {
                    type: 'select',
                    label: 'Include in DRA?',
                    id: 'wIncludeinDRA',
                    data: [
                        { value: 'Y', text: 'Yes' },
                        { value: 'N', text: 'No' },
                    ],
                },
                {
                    type: 'text',
                    label: 'Payroll Processing Order',
                    id: 'wPayrollProcessingOrder',
                },
                {
                    type: 'select',
                    label: 'Service Type',
                    id: 'wServiceType',
                    data: [
                        { value: 'A', text: 'Awake' },
                        { value: 'M', text: 'Mileage' },
                        { value: 'H', text: 'Night' },
                        { value: 'N', text: 'Nursing' },
                        { value: 'O', text: 'Other' },
                        { value: 'R', text: 'Remote Monitoring' },
                    ],
                },
                {
                    type: 'select',
                    label: 'Parent Work Code',
                    id: 'wParentWorkCode',
                    data: getParentWorkCode(),
                    includeBlankOption: true,
                },
                {
                    type: 'text',
                    label: 'Sort Order',
                    id: 'wSortOrder',
                },
                {
                    type: 'text',
                    label: 'EVV CPT Code',
                    id: 'wEVVCPTCode',
                    maxlength: 20,
                },
            ],
        });

        let isKeyTimesDisabled = 'N';
        if (rowData) {
            var findExitingRow = workCodeData.find(a => a.WorkCodeId == rowData.WorkCodeId);
            isKeyTimesDisabled = findExitingRow.isKeyTimesDisabled;
        }
            
        const inputs = ['wWorkCode', 'wDescription', 'wPayrollProcessingOrder', 'wSortOrder', 'wEVVCPTCode'];
        inputs.forEach(input => {
            workCodeForm.inputs[input].onKeyup(event => {
                workCodeForm.inputs['wWorkCode'].setValidtyError('');
                workCodeForm.inputs['wWorkCode'].clearErrorOrWarning();
                checkForRequiredFields(workCodeForm);

                if (workCodeForm.inputs['wWorkCode'].input.value != '' && workCodeForm.inputs['wDescription'].input.value != '') {
                    workCodeForm.buttons['submit'].toggleDisabled(false);
                }

                if (event.target.id == 'wPayrollProcessingOrder') {
                    var numeric = $.isNumeric(workCodeForm.inputs['wPayrollProcessingOrder'].input.value);
                    var num = +workCodeForm.inputs['wPayrollProcessingOrder'].input.value;
                    if (!numeric || num < 0)
                        workCodeForm.inputs['wPayrollProcessingOrder'].input.value = '';
                }
                if (event.target.id == 'wSortOrder') {
                    workCodeForm.inputs['wSortOrder'].setValidtyError('');
                    workCodeForm.inputs['wSortOrder'].clearErrorOrWarning();
                    var numeric = $.isNumeric(workCodeForm.inputs['wSortOrder'].input.value);
                    var num = +workCodeForm.inputs['wSortOrder'].input.value;
                    if (!numeric || num < 0)
                        workCodeForm.inputs['wSortOrder'].input.value = '';
                }
            });
        });

        const selectes = ['wActive', 'wCreateBilling', 'wCreatePayroll', 'wKeyTimes', 'wAllowPayrollOverlaps', 'wIncludeinDRA', 'wServiceType', 'wParentWorkCode'];
        selectes.forEach(select => {
            workCodeForm.inputs[select].onChange(event => {
                workCodeForm.inputs['wWorkCode'].setValidtyError('');
                workCodeForm.inputs['wWorkCode'].clearErrorOrWarning();
                checkForRequiredFields(workCodeForm);

                if (workCodeForm.inputs['wWorkCode'].input.value != '' && workCodeForm.inputs['wDescription'].input.value != '') {
                    workCodeForm.buttons['submit'].toggleDisabled(false);
                }
                if (event.target.id == 'wCreateBilling') {
                    if (workCodeForm.inputs['wCreateBilling'].select.value == 'Y') {
                        workCodeForm.inputs['wKeyTimes'].select.value = 'Y';
                    } else {
                        if (rowData) {
                            workCodeForm.inputs['wKeyTimes'].select.value = findExitingRow.IsKeyTimes;
                        }
                    }
                } 
                if (isKeyTimesDisabled == 'Y' || workCodeForm.inputs['wCreateBilling'].select.value == 'Y') {
                    workCodeForm.inputs['wKeyTimes'].toggleDisabled(true);
                } else {
                    workCodeForm.inputs['wKeyTimes'].toggleDisabled(false);
                }
            });
        });

        workCodeForm.onSubmit(async formdata => { 
            const resp = (
                await _UTIL.fetchData('insertUpdateWorkCodeData', {
                    token: $.session.Token,
                    workCodeId: rowData ? rowData.WorkCodeId : 0,
                    workCode: formdata.wWorkCode,
                    description: formdata.wDescription,
                    isActive: formdata.wActive,
                    isCreateBilling: formdata.wCreateBilling,
                    isCreatePayroll: formdata.wCreatePayroll,
                    isKeyTimes: formdata.wKeyTimes ? formdata.wKeyTimes : 'Y',
                    isAllowPayrollOverlaps: formdata.wAllowPayrollOverlaps,
                    isIncludeinDRA: formdata.wIncludeinDRA,
                    payrollProcessingOrder: formdata.wPayrollProcessingOrder,
                    serviceType: formdata.wServiceType,
                    parentWorkCode: formdata.wParentWorkCode,
                    sortOrder: formdata.wSortOrder,
                    eVVCPTCode: formdata.wEVVCPTCode,
                    userId: $.session.UserId,
                })
            ).insertUpdateWorkCodeDataResult;
            const newID = resp.WorkCodeId;

            if (newID == '-1') {
                workCodeForm.inputs['wWorkCode'].setValidtyError('This work code already exists.');
                workCodeForm.inputs['wWorkCode'].showError('This work code already exists.');
                workCodeForm.buttons['submit'].toggleDisabled(true);
            } else if (newID == '-2') {
                workCodeForm.inputs['wSortOrder'].setValidtyError('The sort order must be unique.');
                workCodeForm.inputs['wSortOrder'].showError('The sort order must be unique.');
                workCodeForm.buttons['submit'].toggleDisabled(true);
            }
            else {
                workCodeForm.clear();
                POPUP.hide(popup);
                await init();
                updateWorkCodeTable();
            }
        });

        workCodeForm.onCancel(event => {
            workCodeForm.clear();
            workCodeForm.buttons['submit'].toggleDisabled(true);
            POPUP.hide(popup);
        });

        workCodeForm.renderTo(popup);

        POPUP.show(popup);

        if (!rowData) {
            workCodeForm.inputs['wKeyTimes'].toggleDisabled(true);
        } else {
            if (rowData.IsCreateBilling == 'Y') {
                rowData.IsKeyTimes = 'Y';
            }
            if (isKeyTimesDisabled == 'Y' || rowData.IsCreateBilling == 'Y') {
                workCodeForm.inputs['wKeyTimes'].toggleDisabled(true);
            } else {
                workCodeForm.inputs['wKeyTimes'].toggleDisabled(false);
            }
        }

        workCodeForm.populate({
            wWorkCode: rowData ? rowData.WorkCode : '',
            wDescription: rowData ? rowData.Description : '',
            wActive: rowData ? rowData.IsActive : 'Y',
            wCreateBilling: rowData ? rowData.IsCreateBilling : 'Y',
            wCreatePayroll: rowData ? rowData.IsCreatePayroll : 'Y',
            wKeyTimes: rowData ? rowData.IsKeyTimes : 'Y',
            wAllowPayrollOverlaps: rowData ? rowData.IsAllowPayrollOverlaps : 'N',
            wIncludeinDRA: rowData ? rowData.IsIncludeDRA : 'Y',
            wPayrollProcessingOrder: rowData ? rowData.PayrollProcessingOrder : 1,
            wServiceType: rowData ? rowData.ServiceType : 'A',
            wParentWorkCode: rowData ? rowData.ParentWorkCode : '',
            wSortOrder: rowData ? rowData.SortOrder : '',
            wEVVCPTCode: rowData ? rowData.EVVCPTCode : '',
        });

        workCodeForm.buttons['submit'].toggleDisabled(true);

        if (!$.session.SetupUpdate && rowData) {
            workCodeForm.disableFormInputs();
        }
    }

    async function handleWorkCodeDelete(row) {
        const rowData = workCodeData.find(a => a.WorkCodeId == row.WorkCodeId);
        if (rowData.isAccountExistCount == 'Y') {
            showUnableToDeletePopup('This work code cannot be deleted, because it is being used somewhere else in Advisor.');
        } else {
            showDeleteConfirmationPopup('Are you sure you want to delete this work code?', async deleteRecord => {
                if (deleteRecord) {
                    await _UTIL.fetchData('deleteWorkCodeSetup', {
                        token: $.session.Token,
                        workCodeId: row.WorkCodeId,
                    })
                    await init();
                    updateWorkCodeTable();
                }
            });
        }
    }
    function updateWorkCodeTable() {
        const tableWorkCodeData = workCodeData
            .map(cd => {
                return {
                    values: [cd.WorkCode, cd.Description, cd.IsActive == 'Y' ? 'Yes' : 'No', cd.IsCreateBilling == 'Y' ? 'Yes' : 'No', cd.IsCreatePayroll == 'Y' ? 'Yes' : 'No'],
                    endIcon: $.session.SetupDelete ? icons['delete'] : '',
                    onClick: e => {
                        showWorkCodePopup(cd);
                    },
                    endIconCallback: () => handleWorkCodeDelete(cd),
                };
            });

        table.populate(workCodeTable, tableWorkCodeData);
    }

    function showDeleteConfirmationPopup(message, callback) {
        const popup = POPUP.build({
            classNames: 'setupDeleteConfirmation',
            hideX: true,
        });

        const messageEle = document.createElement('p');
        messageEle.textContent = message;

        const yesBtn = new Button({
            text: 'Yes',
            style: 'primary',
            styleType: 'contained',
        });
        const noBtn = new Button({
            text: 'No',
            style: 'primary',
            styleType: 'outlined',
        });

        yesBtn.onClick(e => {
            POPUP.hide(popup);
            callback(true);
        });
        noBtn.onClick(e => {
            POPUP.hide(popup);
            callback(false);
        });

        const btnWrapEle = document.createElement('div');
        btnWrapEle.classList.add('btn-wrap');
        yesBtn.renderTo(btnWrapEle);
        noBtn.renderTo(btnWrapEle);

        popup.append(messageEle);
        popup.append(btnWrapEle);

        POPUP.show(popup);
    }
    function showUnableToDeletePopup(message) {
        const popup = POPUP.build({
            classNames: 'unableToDeletePopup',
            hideX: true,
        });

        const messageEle = document.createElement('p');
        messageEle.textContent = message;

        const okBtn = new Button({
            text: 'Ok',
            style: 'primary',
            styleType: 'contained',
        });
        okBtn.onClick(e => {
            POPUP.hide(popup);
        });

        popup.append(messageEle);
        okBtn.renderTo(popup);
        POPUP.show(popup);
    }
    function checkForRequiredFields(formInstance) {
        const invalidElements = formInstance.form.querySelectorAll(`
      input:invalid,
      select:invalid,
      textarea:invalid
    `);

        const isFormValid = Array.from(invalidElements).every(field => field.value && field.value.trim() !== '');

        if (!isFormValid) {
            formInstance.buttons['submit'].toggleDisabled(true);
        } else {
            formInstance.buttons['submit'].toggleDisabled(false);
        }
    }

    function getView(viewName) {
        const viewFragment = document.createDocumentFragment();

        const viewHeading = document.createElement('h1');
        viewHeading.classList.add('viewHeading');
        viewHeading.textContent = `Work Codes`;

        const viewBody = document.createElement('div');
        viewBody.classList.add('viewBody');

        let viewMarkup;

        if (viewName === 'Work Codes') {
            viewMarkup = getWorkCodeView();
        }

        if (viewMarkup) {
            viewFragment.append(viewHeading);
            viewFragment.append(viewBody);
            viewBody.append(viewMarkup);
        }

        return viewFragment;
    }

    async function init() {
        const dataWorkCode = await _UTIL.fetchData('getWorkCodeSetupData', {
            token: $.session.Token,
            userId: $.session.UserId,
        });
        workCodeData = dataWorkCode.getWorkCodeSetupDataResult;
    }

    return {
        init,
        getView,
    };
})();
